import { h } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';
import CaretDown from '../utils/icon/caret-down.svg';
import { useWindowSize } from '../utils/window-size';

const Footermenu = ({ menu, index }) => {
  const [opened, setOpened] = useState(false);
  const { isTablet, isMobile } = useWindowSize();
  return (
    <div
      key={index}
      className="w-full laptop:w-auto border border-t-0 border-l-0 border-r-0 border-black-30 laptop:border-0"
    >
      <p
        className="font-14-bold text-black laptop:mb-[13px] p-[21px] laptop:p-0 laptop:inline-block flex justify-between items-center"
        onClick={() => ((isTablet || isMobile) ? setOpened(!opened) : null)}
      >
        <span>{menu.heading}</span>
        <CaretDown
          className={clsx('block laptop:hidden', opened && 'rotate-180')}
        />
      </p>
      <ul
        className={clsx(
          'overflow-hidden transition-all duration-300 px-[21px] laptop:px-0',
          !(isTablet || isMobile) || opened ? '!max-h-[1000px] mb-4' : 'max-h-0',
        )}
      >
        {menu.menu_links.map((link, i) => (
          <li key={i} className="mb-[17px] laptop:mb-2.5">
            <a
              href={link.title !== "Accessibility" ? link.url : "#"}
              className="font-13 laptop:font-14 text-charcoal inline-block tracking-[-0.7px]"
              data-acsb-custom-trigger={link.title === "Accessibility" ? "true" : undefined}
            >
              {link.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Footermenu;
